// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UnitCard_unit__hS6Nb {
  width: 100%;
  background: white;
  border-radius: 10px;
  padding: 10px;
  min-height: 165px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);
}
.UnitCard_unit__hS6Nb .UnitCard_name__6QYCK {
  font-weight: bold;
  margin-bottom: 5px !important;
}
.UnitCard_unit__hS6Nb .UnitCard_name__6QYCK:hover {
  color: var(--blue);
  text-decoration: underline;
  cursor: pointer;
}
.UnitCard_unit__hS6Nb .UnitCard_bio__4Pita {
  font-size: 13px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.UnitCard_unit__hS6Nb .UnitCard_action-button__5cgCD {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.UnitCard_unit__hS6Nb .UnitCard_action-button__5cgCD .UnitCard_more-information__WhOnn {
  margin-right: 10px;
}
.UnitCard_unit__hS6Nb .UnitCard_action-button__5cgCD svg {
  cursor: pointer;
  width: 20px;
  height: 20px;
}
.UnitCard_unit__hS6Nb .UnitCard_action-button__5cgCD svg path {
  stroke-width: 0.7px;
  stroke: var(--explore-color);
}
.UnitCard_unit__hS6Nb .UnitCard_statistic__1aBVG {
  display: flex;
  align-items: center;
}
.UnitCard_unit__hS6Nb .UnitCard_statistic__1aBVG svg {
  margin-right: 5px;
}
.UnitCard_unit__hS6Nb .UnitCard_statistic__1aBVG p {
  font-size: 13px;
}
.UnitCard_unit__hS6Nb .UnitCard_statistic__1aBVG span {
  font-weight: 600;
}
@media only screen and (max-width: 480px) {
  .UnitCard_unit__hS6Nb {
    border: 1px solid var(--light-grey);
  }
}

.UnitCard_border__cOoXy {
  border: 1px solid var(--light-grey);
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/UnitCard/UnitCard.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,0CAAA;AACF;AAAE;EACE,iBAAA;EACA,6BAAA;AAEJ;AAAE;EACE,kBAAA;EACA,0BAAA;EACA,eAAA;AAEJ;AAAE;EACE,eAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAEJ;AAAE;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AAEJ;AADI;EACE,kBAAA;AAGN;AADI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAGN;AAFM;EACE,mBAAA;EACA,4BAAA;AAIR;AAAE;EACE,aAAA;EACA,mBAAA;AAEJ;AADI;EACE,iBAAA;AAGN;AADI;EACE,eAAA;AAGN;AADI;EACE,gBAAA;AAGN;AACE;EAzDF;IA0DI,mCAAA;EAEF;AACF;;AAAA;EACE,mCAAA;AAGF","sourcesContent":[".unit {\n  width: 100%;\n  background: white;\n  border-radius: 10px;\n  padding: 10px;\n  min-height: 165px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.15);\n  .name {\n    font-weight: bold;\n    margin-bottom: 5px !important;\n  }\n  .name:hover {\n    color: var(--blue);\n    text-decoration: underline;\n    cursor: pointer;\n  }\n  .bio {\n    font-size: 13px;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n  .action-button {\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    .more-information {\n      margin-right: 10px;\n    }\n    svg {\n      cursor: pointer;\n      width: 20px;\n      height: 20px;\n      path {\n        stroke-width: 0.7px;\n        stroke: var(--explore-color);\n      }\n    }\n  }\n  .statistic {\n    display: flex;\n    align-items: center;\n    svg {\n      margin-right: 5px;\n    }\n    p {\n      font-size: 13px;\n    }\n    span {\n      font-weight: 600;\n    }\n  }\n\n  @media only screen and (max-width: 480px) {\n    border: 1px solid var(--light-grey);\n  }\n}\n.border {\n  border: 1px solid var(--light-grey);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"unit": `UnitCard_unit__hS6Nb`,
	"name": `UnitCard_name__6QYCK`,
	"bio": `UnitCard_bio__4Pita`,
	"action-button": `UnitCard_action-button__5cgCD`,
	"more-information": `UnitCard_more-information__WhOnn`,
	"statistic": `UnitCard_statistic__1aBVG`,
	"border": `UnitCard_border__cOoXy`
};
export default ___CSS_LOADER_EXPORT___;
